/*
 * @Author: Wang Bingjing
 * @Date: 2021-04-23 16:10:50
 * @LastEditTime: 2021-04-28 10:10:27
 * @LastEditors: Wang Bingjing
 */
export const ADMIN = 'admin'
export const LEADER = 'leader'
export const STAFF = 'staff'